import { FormControl, OutlinedInput } from "@mui/material";
import { CustomTypography } from "../CustomTypography/CustomTypography";
import useStyles from "./styles";
import { ChangeEventHandler, FocusEventHandler } from "react";
import { FieldError } from "../FieldError/FieldError";

type Props = {
  placeholder?: string;
  label?: string;
  marginBottom?: string | number;
  rows?: string | number;
  onChange?:
    | ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  value?: unknown;
  name?: string;
  type?: string;
  disabled?: boolean;
  /** Inline validation message shown under the field. */
  helperTextError?: string;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

export const CustomTextInput: React.FC<Props> = ({
  placeholder,
  label,
  marginBottom,
  rows,
  value,
  name,
  type,
  disabled,
  helperTextError,
  onChange,
  onBlur,
}) => {
  const classes = useStyles({ marginBottom, rows });

  return (
    <div className={classes.container}>
      {label && (
        <div className={classes.containerLabel}>
          <CustomTypography
            text={label}
            variant={"link"}
            textDecoration={"none"}
          />
        </div>
      )}
      <FormControl className={classes.formControl} variant="outlined">
        <OutlinedInput
          fullWidth
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          multiline={rows ? true : false}
          rows={rows}
          disabled={disabled}
          error={!!helperTextError}
          inputProps={{ "aria-label": label?.replace(/\s*\*\s*$/, "") }}
        />
      </FormControl>
      <FieldError message={helperTextError} />
    </div>
  );
};
